import types from "../actions/types";

const initialState = {};

export function referral(state = initialState, action) {
    switch (action.type) {
        case types.REFERRAL_FETCH_CODE_REQUEST:
        case types.REFERRAL_FETCH_STATS_REQUEST:
            return { ...state, loading: true, error: false };
        case types.REFERRAL_FETCH_CODE_SUCCESS:
            return { ...state, referralCode: action.referralCode, loading: false, error: false };
        case types.REFERRAL_FETCH_STATS_SUCCESS:
            return { ...state, stats: action.stats, loading: false, error: false };
        case types.REFERRAL_FETCH_CODE_ERROR:
        case types.REFERRAL_FETCH_STATS_ERROR:
            return { ...state, loading: false, error: true, errorMsg: action.errorMsg };
        case types.REFERRAL_RESET:
            return initialState;
        default:
            return state;
    }
}
